// TODO: Is this module already included in @react-common?
import { getCookie, setCookie } from "../3rdparty/cookie"; // TODO: Import from @react-common/functions
import {
  oneLangLocaleToCanonicalLocaleId,
  canonicalLocaleIdToOneLangLocale,
} from "@one.com/i18n-tools/onelang-helper";

export var supportedLocaleIds = [
  "da-DK",
  "de-DE",
  "en-US",
  "en-GB",
  "es-ES",
  "fi-FI",
  "fr-FR",
  "it-IT",
  "nb-NO",
  "nl-NL",
  "pt-PT",
  "sv-SE",
];
export const defaultLocaleId = "en-US";
export const unsupportedLocales = ["pl-PL", "pt-BR", "cs-CZ"];

export function getLanguageCookieValue() {
  const oneLangCookie = getCookie("OneLang");

  if (oneLangCookie) {
    const canonicalLocaleId = oneLangLocaleToCanonicalLocaleId(oneLangCookie);

    if (
      canonicalLocaleId === "en-GB" ||
      unsupportedLocales.indexOf(canonicalLocaleId) !== -1
    ) {
      // We don't actually translate to british english
      return "en-US";
    }

    return canonicalLocaleId;
  }

  return defaultLocaleId;
}

export const activeLocale = getLanguageCookieValue();

// changeLocale is used only in tests
export function changeLocale(newLocale) {
  var oneLangValue = canonicalLocaleIdToOneLangLocale(newLocale);
  if (!oneLangValue) {
    throw new Error("Invalid locale id.");
  }

  var cookieOptions = {
    path: "/",
    expires: 365 * 2, // Value given in days: ~2 years
  };

  var hostname = window.location.hostname;
  if (hostname !== "localhost") {
    cookieOptions.domain = "." + hostname.split(".").splice(-2, 2).join(".");
  }

  setCookie({
    name: "OneLang",
    value: oneLangValue,
    ...cookieOptions,
  });
}

export const getLangFromLocale = (locale) => {
  const localeToLang = {
    "da-DK": "da",
    "de-DE": "de",
    "en-US": "en",
    "en-GB": "en",
    "es-ES": "es",
    "fi-FI": "fi",
    "fr-FR": "fr",
    "it-IT": "it",
    "nb-NO": "no",
    "nl-NL": "nl",
    "pt-PT": "pt",
    "sv-SE": "sv",
  };
  return localeToLang[locale] || "en";
};
